import React from 'react'
import dayjs from 'dayjs'
import classNames from 'classnames'
import { InfoCircle, MapPin } from 'iconoir-react'
import { RunObjectColors } from '../../../../../services/RunObjectColors'

const PcSortedGroupedRunsCard = ({
    run,
    onCardClicked,
    onInfoClicked,
    fromGlobalView = false,
    showRunObjectColors,
}) => {
    return (
        <div
            key={run.id}
            className={classNames(
                `sorted-pc-run-car-grid grid rounded border-l-4 shadow-mobile ${run.statusBorderColor}`,
                {
                    stripeBg: run.partner && run.isGiven,
                    stripeBg_canceled:
                        run.status.id === 'canceled' && !run.selected,
                    'bg-white text-gray-800': !run.selected || fromGlobalView,
                    'bg-light-dark-green text-white':
                        run.selected && !fromGlobalView,
                    [`${RunObjectColors[run.runObject.color]}`]:
                        showRunObjectColors && !run.selected,
                }
            )}
            id={run.id}
        >
            <div
                className={classNames(
                    'h-42 col-span-1 flex items-center justify-between px-2 py-1 text-base',
                    {
                        'cursor-pointer': !fromGlobalView,
                    }
                )}
                onClick={() => {
                    if (!fromGlobalView) {
                        onCardClicked(run)
                    }
                }}
            >
                <div className="flex w-2/12 justify-between px-2">
                    <div className="flex w-full flex-row font-semibold">
                        <div className="flex justify-center">
                            {run.departureTimeHour}
                        </div>
                        <div className="">-</div>
                        <div className="flex justify-center">
                            {run.arrivingTimeHour}
                        </div>
                    </div>
                </div>
                <div className="w-4/12 truncate pt-2 text-sm font-semibold lg:pt-0">
                    {run.groupedRuns.map((r) => (
                        <div>
                            <span className="truncate">{r.patientName}</span>
                        </div>
                    ))}
                </div>
                <div className="flex w-2/12 items-center justify-center">
                    <i className="fas fa-layer-group" />
                </div>
                <div className="flex w-4/12">
                    <div className="flex items-center justify-center space-x-2 truncate">
                        <span>
                            <MapPin />
                        </span>
                        <span className="truncate">
                            {run.groupedRuns.map((r) => (
                                <div>
                                    <span className="truncate text-sm">
                                        {r.depositAddress}
                                    </span>
                                </div>
                            ))}
                        </span>
                    </div>
                </div>
            </div>
            {!fromGlobalView && (
                <div className="col-span-1 flex cursor-pointer items-center justify-center hover:scale-110">
                    <div
                        className="text-xl"
                        onClick={() => {
                            onInfoClicked(run)
                        }}
                    >
                        <InfoCircle />
                    </div>
                </div>
            )}
        </div>
    )
}

export default PcSortedGroupedRunsCard
